"use client";

import Link from "next/link";
import { PhoneIcon } from "@heroicons/react/24/outline";

interface BeginJourneyProps {
  description?: string;
}

export default function BeginJourney({
  description = "",
}: BeginJourneyProps) {
  return (
    <>
      <section
        className="relative overflow-hidden bg-gradient-to-r from-brand-blue/10 to-brand-pink/10 py-20"
        data-oid="_ojn9xe"
      >
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, #ec6680 1px, transparent 0)",
            backgroundSize: "24px 24px",
          }}
          data-oid="3wckshm"
        />

        <div className="container relative mx-auto px-4" data-oid=":2gr_0h">
          <div className="mx-auto max-w-4xl text-center" data-oid="gaarfag">
            <h2
              className="mb-6 text-3xl font-semibold text-brand-blue md:text-4xl"
              data-oid="o_:31rh"
            >
              Begin Your Fertility Journey Today
            </h2>
            <p
              className="mx-auto mb-10 max-w-2xl text-lg leading-relaxed text-gray-600"
              data-oid="kza_l0c"
            >
              {description}
            </p>
            <div
              className="flex flex-col items-center justify-center gap-4 sm:flex-row"
              data-oid="knpzx__"
            >
              <Link
                href="/contact"
                className="group inline-flex items-center gap-2 rounded-lg bg-brand-pink px-6 py-3 text-lg font-semibold text-white transition-all duration-300 hover:bg-brand-light-pink hover:shadow-lg"
                data-oid="jb98gga"
              >
                <PhoneIcon
                  className="h-5 w-5 transition-transform duration-300 group-hover:-rotate-12"
                  data-oid="2bk06zy"
                />
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Decorative footer pattern */}
      <div
        className="h-2 bg-gradient-to-r from-brand-blue via-brand-pink to-brand-light-pink"
        data-oid="okkwtig"
      />
    </>
  );
}
